import React, { useState, useEffect } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import 'katex/dist/katex.min.css'
import { FloatingSubmit } from '../UIUtilsFiles/FloatingSubmit'
import { ComponentQuestion } from '../UIUtilsFiles/ComponentQuestion'

function TrueFalseChoiceComponent(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    screenMode,
    handleSucAndFailFeedback,
    onDisplayDoneClick,
    isResetClick,
    isPageRefresh
  } = props
  const {
    ControlID,
    Answers,
    Options,
    Score,
    AnswerColorFill,
    AnswerFontSize,
    AnswerFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    QuestionHeight,
    SequenceHint,
    Priority,
    TextAlign,
    FontStyle,
    Italic,
    Bold,
    QuestionText,
    QuestionFontSize,
    FeedbackAudioData
  } = mcData
  const canvasAreaHeight = 100 - QuestionHeight

  const [trueFalseValueArray, setTrueFalseValueArray] = useState([])
  const [displayDone, setDisplayDone] = useState(false)
  const [onBlurCall, setOnBlurCall] = useState(true)
  const [failureCount, setFailureCount] = useState(0)

  useEffect(() => {
    if (onBlurCall) {
      if (defaultValue) {
        if (defaultValue.CtlValue) {
          let defaultValueSelected = defaultValue.CtlValue
          setTrueFalseValueArray(defaultValueSelected)
        }
        setOnBlurCall(false)
      } else {
        let valueArray = []
        for (let i = 0; i < Options.length; i++) {
          valueArray[i] = ''
        }
        setTrueFalseValueArray(valueArray)
      }
    }
  }, [defaultValue, onBlurCall])

  useEffect(() => {
    if (isResetClick) {
      setOnBlurCall(true)
    }
  }, [isResetClick])

  useEffect(() => {
    if (isPageRefresh) {
      setOnBlurCall(true)
    }
  }, [isPageRefresh])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, trueFalseValueArray)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    if (JSON.stringify(trueFalseValueArray) === JSON.stringify(Answers)) {
      onExplanationVisible(true, CorrectAnswerExplanation)
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  //Hide tick icon when activity is completed
  useEffect(() => {
    if (completed === 1 || !isActive) {
      setDisplayDone(false)
    }
  }, [completed, isActive])

  useEffect(() => {
    if (onDisplayDoneClick) {
      if (displayDone) {
        onDisplayDoneClick({ id: ControlID, displayDone: displayDone })
      } else {
        onDisplayDoneClick({ id: undefined, displayDone: displayDone })
      }
    }
  }, [displayDone])

  function handleSelection(index, selectionType) {
    if (completed === 0 && isActive && !explanationClick) {
      let trueFalseValueArrayCopy = [...trueFalseValueArray]
      trueFalseValueArrayCopy[index] = selectionType
      setTrueFalseValueArray(trueFalseValueArrayCopy)
      if (Answers[index] === selectionType) {
        handleSuccessChange(true)
      } else {
        handleSuccessChange(false)
      }
      if (isEmbeded) {
        setDisplayDone(true)
      } else {
        onAttemptChange(1)
        validateCorrectAnswer(false, trueFalseValueArrayCopy)
      }
    }
  }

  //Failure message Sequence
  function handleFailureFeedback() {
    let feedbackAudioData = FeedbackAudioData.failureData
    let failureFeedback = {}
    if (feedbackAudioData.length > 0) {
      if (failureCount === 0) {
        setFailureCount(1)
        failureFeedback = feedbackAudioData[0]
      } else if (failureCount === 1) {
        setFailureCount(2)
        failureFeedback = feedbackAudioData[1]
      } else if (failureCount === 2) {
        setFailureCount(0)
        failureFeedback = feedbackAudioData[2]
      }
    } else {
      failureFeedback = {
        failureAudioLink: '',
        failureFeedback: []
      }
    }
    handleSucAndFailFeedback(false, failureFeedback)
  }

  function validateCorrectAnswer(timerValue, trueFalseValueArrayCopy) {
    //check all the t/f are attend
    let selectedCopy = []
    for (let index = 0; index < trueFalseValueArrayCopy.length; index++) {
      if (trueFalseValueArrayCopy[index] !== undefined) {
        selectedCopy.push(trueFalseValueArrayCopy[index])
      }
    }
    //Change priority value
    if (onPriorityChange && followTheFlow && isEmbeded) {
      if (isPractice) {
      } else {
        if (selectedCopy.length >= Answers.length) {
          onPriorityChange(Priority)
        }
      }
    }

    if (JSON.stringify(trueFalseValueArrayCopy) === JSON.stringify(Answers)) {
      onValueChange(
        ControlID,
        trueFalseValueArrayCopy,
        Score,
        Score,
        '',
        timerValue
      )
      //check selected answer correct
      if (selectedCopy.length >= Answers.length) {
        if (followTheFlow && isPractice) {
          handleSucAndFailFeedback(true, FeedbackAudioData.successData)
        }
      }
    } else {
      onValueChange(
        ControlID,
        trueFalseValueArrayCopy,
        0,
        Score,
        '',
        timerValue
      )
      //check selected answer correct
      if (selectedCopy.length >= Answers.length) {
        if (followTheFlow && isPractice) {
          handleFailureFeedback()
        }
      }
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
      style={{
        display: 'flex',
        padding: isEmbeded ? '5px' : '0px 0px 0px 0px',
        justifyContent: 'center'
      }}
    >
      {isEmbeded && QuestionText && (
        <ComponentQuestion
          QuestionText={QuestionText}
          FontStyle={FontStyle}
          Italic={Italic}
          Bold={Bold}
          QuestionFontSize={QuestionFontSize}
        />
      )}
      {isEmbeded && displayDone && (
        <FloatingSubmit
          submitClicked={() => {
            onAttemptChange(1)
            validateCorrectAnswer(false, trueFalseValueArray)
            setOnBlurCall(true)
            setDisplayDone(false)
          }}
        />
      )}
      {Options &&
        Options.map((item, index) => {
          return (
            <div
              key={index.toString()}
              style={{
                width: isEmbeded ? '100%' : '90%',
                display: 'flex',
                flexDirection: 'row',
                marginBottom: '2%',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  width: isEmbeded
                    ? '60%'
                    : screenMode === 'phone'
                    ? '56%'
                    : '60%',
                  backgroundColor: AnswerFillColor,
                  borderRadius: '10px',
                  padding: '5px',
                  border: '1px solid #B5B5B5',
                  borderRadius: '4px'
                }}
              >
                <p
                  style={{
                    color: AnswerColorFill,
                    fontSize:
                      AnswerFontSize === 'SMALL'
                        ? SMALL_DESKTOP
                        : AnswerFontSize === 'LARGE'
                        ? LARGE_DESKTOP
                        : MEDIUM_DESKTOP,
                    margin: 0,
                    textAlign: TextAlign
                      ? TextAlign === 'left'
                        ? 'left'
                        : TextAlign === 'right'
                        ? 'right'
                        : 'center'
                      : 'center',
                    fontFamily: FontStyle,
                    fontStyle: Italic === 'True' ? 'italic' : 'normal',
                    fontWeight: Bold === 'True' ? 'bold' : 'normal'
                  }}
                >
                  {item}
                </p>
              </div>
              <div
                style={{
                  width: '20%',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
              >
                <p
                  className='card-shadow'
                  style={{
                    width: isEmbeded
                      ? '80%'
                      : screenMode === 'phone'
                      ? '100%'
                      : '100px',
                    color: isPractice
                      ? trueFalseValueArray[index] === true
                        ? '#ffffff'
                        : AnswerColorFill
                      : AnswerColorFill,
                    backgroundColor: isVerifyMode
                      ? Answers[index] === true
                        ? '#3EC986'
                        : '#ff551f'
                      : isPractice || completed === 1 || !isActive
                      ? trueFalseValueArray[index] === true
                        ? Answers[index] === true
                          ? '#3EC986'
                          : '#ff551f'
                        : AnswerFillColor
                      : trueFalseValueArray[index] === true
                      ? SelectionColor
                      : AnswerFillColor,
                    border: '1px solid #B5B5B5',
                    borderRadius: '4px',
                    marginLeft: '2%',
                    marginRight:
                      !isEmbeded && screenMode === 'phone' ? '2%' : 0,
                    marginBottom: 0,
                    textAlign: 'center',
                    fontSize: MEDIUM_DESKTOP,
                    cursor: 'pointer',
                    animationName:
                      isPractice || completed === 1
                        ? trueFalseValueArray[index] === true
                          ? Answers[index] === true
                            ? 'pulse_animation'
                            : 'shake_animation'
                          : 'unset'
                        : trueFalseValueArray[index] === true
                        ? 'flip_animation'
                        : 'unset',
                    animationDuration: '200ms',
                    padding: '5px',
                    fontFamily: FontStyle,
                    fontStyle: Italic === 'True' ? 'italic' : 'normal',
                    fontWeight: Bold === 'True' ? 'bold' : 'normal'
                  }}
                  onClick={() => {
                    if (isPractice && followTheFlow && isEmbeded) {
                      if (
                        JSON.stringify(trueFalseValueArray) ===
                        JSON.stringify(Answers)
                      ) {
                      } else {
                        handleSelection(index, true)
                      }
                    } else {
                      handleSelection(index, true)
                    }
                  }}
                >
                  True
                </p>
              </div>
              <div
                style={{
                  width: '20%',
                  display: 'flex'
                }}
              >
                <p
                  className='card-shadow'
                  style={{
                    width: isEmbeded
                      ? '85%'
                      : screenMode === 'phone'
                      ? '100%'
                      : '100px',
                    textAlign: 'center',
                    color: isPractice
                      ? trueFalseValueArray[index] === false
                        ? '#ffffff'
                        : AnswerColorFill
                      : AnswerColorFill,
                    fontSize: MEDIUM_DESKTOP,
                    backgroundColor: isVerifyMode
                      ? Answers[index] === false
                        ? '#3EC986'
                        : '#ff551f'
                      : isPractice || completed === 1 || !isActive
                      ? trueFalseValueArray[index] === false
                        ? Answers[index] === false
                          ? '#3EC986'
                          : '#ff551f'
                        : AnswerFillColor
                      : trueFalseValueArray[index] === false
                      ? SelectionColor
                      : AnswerFillColor,
                    border: '1px solid #B5B5B5',
                    borderRadius: '4px',
                    marginLeft: !isEmbeded && screenMode === 'phone' ? 0 : '5%',
                    marginBottom: 0,
                    cursor: 'pointer',
                    animationName:
                      isPractice || completed === 1
                        ? trueFalseValueArray[index] === false
                          ? Answers[index] === false
                            ? 'pulse_animation'
                            : 'shake_animation'
                          : 'unset'
                        : trueFalseValueArray[index] === false
                        ? 'flip_animation'
                        : 'unset',
                    animationDuration: '200ms',
                    padding: '5px',
                    fontFamily: FontStyle,
                    fontStyle: Italic === 'True' ? 'italic' : 'normal',
                    fontWeight: Bold === 'True' ? 'bold' : 'normal'
                  }}
                  onClick={() => {
                    if (isPractice && followTheFlow && isEmbeded) {
                      if (
                        JSON.stringify(trueFalseValueArray) ===
                        JSON.stringify(Answers)
                      ) {
                      } else {
                        handleSelection(index, false)
                      }
                    } else {
                      handleSelection(index, false)
                    }
                  }}
                >
                  False
                </p>
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default TrueFalseChoiceComponent
